import React, { useState } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";

interface Tab {
  key: string;
  label: string;
}

interface Props {
  tabs: Tab[];
  activeTabKey: string;
  onClick: (tabKey: string) => void;
}

const SwitchTabs: React.FC<Props> = ({ tabs, activeTabKey, onClick }) => {
  const { t, i18n } = useTranslation("app");

  const active = activeTabKey;
  const activeIndex = tabs.findIndex((tab) => tab.key === active);

  const handleSwitch = (tabKey: string) => {
    if (tabKey !== active) {
      onClick(tabKey);
    }
  };

  return (
    <div className="switch-tab-btns-container">
      <div
        className="switch-background"
        style={{
          left: `calc(${(activeIndex / tabs.length) * 100}% 
          ${
            activeIndex + 1 === tabs.length
              ? "- 0px"
              : activeIndex === 0
              ? "+ 2.5px"
              : ""
          })`,
          width: `calc(${100 / tabs.length}%  ${
            activeIndex + 1 === tabs.length || activeIndex === 0 ? "- 2px" : ""
          })`,
        }}
      />
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`switch-btn ${active === tab.key ? "active" : ""}`}
          style={{
            width: `calc(${100 / tabs.length}% )`,
            padding:
              i18n.language === "am" && tabs.length > 2
                ? `0px ${tabs.length !== 2 ? "16px" : "0px"}`
                : `0px ${tabs.length !== 2 ? "24px" : "0px"}`,
            fontSize:
              i18n.language === "am" && tabs.length > 2 ? "12px" : "14px",
            lineHeight:
              i18n.language === "am" && tabs.length > 2 ? "14px" : "16px",
          }}
          onClick={() => handleSwitch(tab.key)}
        >
          {t(tab.label)}
        </button>
      ))}
    </div>
  );
};

export default SwitchTabs;

//       left: active === tabs[0].key ? "calc(0% + 2px)" : "calc(50% - 2px)",
//       <div
//         className="switch-background"
//         style={{
//           left: active === "exchange" ? "calc(0% + 2px)" : "calc(50% - 2px)",
//         }}
//       />
//       <button
//         className={`switch-btn ${active === "exchange" ? "active" : ""}`}
//         onClick={() => handleSwitch("exchange")}
//       >
//         {t("exchange2")}
//       </button>
//       <button
//         className={`switch-btn ${active === "trading" ? "active" : ""}`}
//         onClick={() => handleSwitch("trading")}
//       >
//         {t("trading")}
//       </button>
//     </div>
